function initRechargeCustomization() {
    const widgetInterval = setInterval(addSubscriptionWidgets, 250);

    function addSubscriptionWidgets() {
        if (!window.ReChargeWidget) return console.log("PF: Recharge not found");
        window.ReChargeWidget.useVariantIdElement = true;
        const productCards = document.querySelectorAll(".card[data-productid]:not(.edited)");
        productCards.forEach((prodCard) => {
            const currentProdId = prodCard.getAttribute("data-productid");

            const config = {
                productId: currentProdId, // Required
                injectionParent: `.card[data-productid="${currentProdId}"] form[action*='/cart/add']`, // The node that will have the widget injected in
                injectionMethod: "prepend", // How will the widget be injected
                injectFn: (node, target) => { }, // Runs a custom injection function
                selectors: {
                    price: [`.card[data-productid="${currentProdId}"] .price-item`], // the selectors that will be updated based on subscription
                    variant: [
                        `.card[data-productid="${currentProdId}"] variant-selects`,
                        `.card[data-productid="${currentProdId}"] variant-selects input`,
                        `.card[data-productid="${currentProdId}"] .product-form input[name='id']`,
                    ], // The variants to watch for to update the subscription prices
                },
            };

            window.ReChargeWidget.createWidget(config);
            prodCard.classList.add("edited")
        });

        clearInterval(widgetInterval);
        const fixInputIssue = setInterval(fixEmptySellingPlanInput, 200);
        setTimeout(() => clearInterval(fixInputIssue), 4000);
    }

    function fixEmptySellingPlanInput() {
        document
            .querySelectorAll(
                ".card[data-productid] form[action*='/cart/add'] > input[name='selling_plan']"
            )
            .forEach((input) => input.remove());
    }

    document.addEventListener("click", (e) => {
        if (!e.target.closest(".product-card-wrapper .card__inner")) return;

        const prodUrl = e.target.closest(".card")?.querySelector(".card__heading a")?.getAttribute("href");
        if (!prodUrl)
            return console.log("PF: URL not found")

        window.location.href = prodUrl;
    });
}

// Check if device is mobile
function isMobileDevice() {
    return window.innerWidth <= 768;
}

document.addEventListener("DOMContentLoaded", () => {
    isMobileDevice() && initRechargeCustomization();
});